import { reactive, set } from "vue-demi";
const getInitialValue = (field) => {
  const fieldTypeInitializers = {
    checkbox: () => false,
    checkbox_group: () => [],
    radio: () => null,
    select: (field2) => {
      if (field2.attributes.multiple === true) {
        return [];
      }
      return "";
    },
    hidden: (field2) => field2.attributes.value || "",
    default: () => ""
  };
  return (fieldTypeInitializers[field.type] || fieldTypeInitializers.default)(
    field
  );
};
export const useFormValues = (formData) => {
  const formValues = reactive({});
  const initializeFormValues = () => {
    formData.steps.forEach((step) => {
      step.fields.forEach((field) => {
        set(formValues, field.name, getInitialValue(field));
      });
    });
  };
  initializeFormValues();
  return {
    formValues
  };
};
